<div class="empty-state flex flex-column align-items-center justify-content-center text-center py-6 px-4 card">

  <div class="empty-state__illustration mb-5">
    <img
      *ngIf="illustration"
      [src]="illustration"
      [alt]="title"
      class="empty-state__image"
    />
    <svg
      *ngIf="!illustration"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 180"
      class="empty-state__default-svg"
      aria-hidden="true"
    >
      <circle cx="96" cy="84" r="68" fill="var(--surface-100, #F1F5F9)" />
      <circle
        cx="90"
        cy="78"
        r="38"
        fill="var(--surface-0, #ffffff)"
        stroke="var(--surface-400, #94A3B8)"
        stroke-width="5"
      />
      <line x1="75" y1="70" x2="105" y2="70" stroke="var(--surface-300, #CBD5E1)" stroke-width="4" stroke-linecap="round" />
      <line x1="75" y1="81" x2="105" y2="81" stroke="var(--surface-300, #CBD5E1)" stroke-width="4" stroke-linecap="round" />
      <line x1="75" y1="92" x2="95"  y2="92" stroke="var(--surface-300, #CBD5E1)" stroke-width="4" stroke-linecap="round" />
      <line
        x1="118"
        y1="108"
        x2="144"
        y2="138"
        stroke="var(--surface-400, #94A3B8)"
        stroke-width="7"
        stroke-linecap="round"
      />
    </svg>
  </div>

  <h2 class="text-900 font-bold text-3xl mb-3 mt-0">{{ title }}</h2>

  <p
    *ngIf="description"
    class="text-600 text-lg line-height-3 mb-5 mt-0 empty-state__description"
  >{{ description }}</p>

  <ng-container *ngIf="ctaLabel">
    <p-button
      *ngIf="ctaRoute; else actionButton"
      [label]="ctaLabel"
      [routerLink]="ctaRoute"
      styleClass="p-button-raised font-medium"
    />
    <ng-template #actionButton>
      <p-button
        [label]="ctaLabel"
        (click)="onCtaClick()"
        styleClass="p-button-raised font-medium"
      />
    </ng-template>
  </ng-container>

</div>
